import {
  enableProdMode,
  importProvidersFrom,
  isDevMode,
  ErrorHandler,
  provideAppInitializer,
  inject,
  provideZoneChangeDetection
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { routes } from './app/app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { GlobalErrorHandler } from './app/services/global-error-handler.service';
import { NetworkService } from './app/services/network.service';
import { MigrationService } from './app/services/migration.service';
import { performanceInterceptor } from './app/interceptors/performance.interceptor';

if (environment.production) {
  enableProdMode();
}

// Bootstrap in its own task: evaluating main.js and bootstrapping in one task was a single ~500 ms frame
// at 4x CPU (ERH-226); split, the browser can paint in between.
setTimeout(() =>
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: ErrorHandler, useClass: GlobalErrorHandler },
      provideAnimationsAsync(),
      importProvidersFrom(IonicModule.forRoot()),
      importProvidersFrom(IonicStorageModule.forRoot()),
      provideHttpClient(withXhr(), withInterceptors([performanceInterceptor])),
      provideRouter(routes),
      // First initializer: settings handed over from e-rhema.ch must be in storage before any service reads it.
      provideAppInitializer(() => inject(MigrationService).importFromLocation()),
      // DataService picks API vs storage synchronously per call, so native connectivity must be known first.
      provideAppInitializer(() => inject(NetworkService).whenKnown()),
      provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      })
    ]
  })
);
